import React, { createContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { initialFilterState } from './constants';
import { AppState } from '../../reducers';
import { IFilterState } from './types';
import { ProductCondition, Variant as VariantType } from '../../types';

const initialContextValue: IPriceListFilterContext = {
  filters: initialFilterState,
  setFilters: () => undefined,
  reload: () => undefined,
};

export const PriceListFilterContext = createContext<IPriceListFilterContext>(
  initialContextValue
);

export const PriceListFilterContextContainer: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = props => {
  const [filters, setFilters] = useState<IFilterState>(initialFilterState);
  const selectedVariant = useSelector(
    (state: AppState) => state.areas.product.variant
  );

  const selectedCondition = useSelector(
    (state: AppState) => state.areas.product.condition
  );

  const reload = (
    newFilters: IFilterState,
    routeDispatch: (action: any) => void,
    variant?: VariantType | null,
    condition?: ProductCondition
  ) => {
    setFilters(newFilters);
    routeDispatch({
      type: 'PRICE_FILTER',
      options: {
        ...newFilters,
      },
      variant: variant !== undefined ? variant : selectedVariant,
      condition: condition ?? selectedCondition,
    });
  };

  return (
    <PriceListFilterContext.Provider
      value={{
        filters,
        setFilters,
        selectedVariant,
        selectedCondition,
        reload,
      }}
    >
      {props.children}
    </PriceListFilterContext.Provider>
  );
};
interface IPriceListFilterContext {
  filters: IFilterState;
  selectedVariant?: VariantType | null;
  selectedCondition?: ProductCondition | null | undefined;
  setFilters: React.Dispatch<React.SetStateAction<IFilterState>>;
  reload: (
    newFilters: IFilterState,
    routeDispatch: (action: any) => void,
    variants?: VariantType | null,
    condition?: ProductCondition
  ) => void;
}
